import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
// import Button from '../Button';
// import Form from '../Form';
// import TextInput from '../TextInput';
import './styles.scss';
import routeTemplates from '../../../routes/templates';
import styles from '../../../../app/layout/header/index.module.scss';
import { withRouter } from 'react-router-dom';
import InternalLink from '../../../internal-link';
// import goSchoolPNG from 'resources/common/go-school.png';

const Footer = ({
  inverted,
  className,
  children,
  columnItemsOne,
  columnItemsTwo,
  columnItemsThree,
  socialNavItems,
  footerBottomNavItems,
  copyrightText,
  newsLetterText,
  history,
  ...other
}) => {
  const classNames = classnames({
    footer: true,
    className: true,
    'bg-white': false,
  });

  const footer = children ? (
    <div {...other} className={classNames} style={{ position: 'relative' }}>
      {children}
    </div>
  ) : (
    <div className={classnames(classNames, 'pt-4')} style={{ position: 'relative' }}>
      <InternalLink to={routeTemplates.root}>
        <img
          className={classnames(styles.logo, 'mx-auto')}
          src="https://indorse-staging-bucket.s3.amazonaws.com/vital/DAK+Logo+White.png"
          alt="logo"
        />
      </InternalLink>
      <div className="text-center mt-4">
        <small style={{ color: '#e9e9e9' }}>
          © 2021 Data Analytics Kickstarter. All Rights Reserved.
        </small>
      </div>
      <div className="container mx-auto policy">
        {/* <hr style={{ backgroundColor: '#e9e9e9' }} /> */}
        <div className="text-center pb-3">
          <small>
            This site is protected by reCAPTCHA and the Google{' '}
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
          </small>
        </div>
      </div>
    </div>
  );

  return footer;
};

Footer.propTypes = {
  inverted: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  labelOne: PropTypes.string,
  linkTextOne: PropTypes.string,
  linkHrefOne: PropTypes.string,
  labelTwo: PropTypes.string,
  linkTextTwo: PropTypes.string,
  linkHrefTwo: PropTypes.string,
  buttonText: PropTypes.string,
};

Footer.defaultProps = {
  labelOne: 'Need Help?',
  linkTextOne: 'Contact Bluemix Sales',
  linkHrefOne: '#',
  labelTwo: 'Estimate Monthly Cost',
  linkTextTwo: 'Cost Calculator',
  linkHrefTwo: '#',
  buttonText: 'Create',
};

export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/Footer/Footer.js